import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Checkbox from '../Checkbox'

// DON NOT REMOVE the comments around 'import style.scss'
// ###STYLE_REPLACEMENT_START###
import './style.scss'
// ###STYLE_REPLACEMENT_END###

const CheckboxGroup = ({ id, label, onChange, extraClasses, options, selecteds, disabled, ...restProps }) => {
  // const [selectedItems, setSelectedItems] = useState(selecteds)

  /*
  const onSelectedChanged = (selected) => (checked) => {
    const newSelected = selectedItems
    if (!newSelected.includes(selected) && checked) {
      newSelected.push(selected)
    }
    if (newSelected.includes(selected) && !checked) {
      newSelected.splice(newSelected.indexOf(selected), 1)
    }
    onChange(newSelected)
    setSelectedItems([...newSelected])
  }
  */

  const onSelectedChanged = (childLabel) => (checked) => {
    onChange(childLabel, checked)
  }

  return (
    <div
      className={classnames('gdpp-component fil-checkboxGroup', {
        [extraClasses]: extraClasses
      })}
    >
      <label id={`fil-checkboxGroup__label-${label}`} className="fil-checkboxGroup__label" htmlFor={id}>
        {label}
      </label>
      {options.map((option) => (
        <div className="fil-checkboxGroup__checkbox" key={id + option.label}>
          <Checkbox
            id={option.label}
            onChange={(e) => onSelectedChanged(option.label)(e)}
            label={option.label}
            checked={option.checked}
            disabled={option.disabled}
            {...restProps}
          />
        </div>
      ))}
    </div>
  )
}

CheckboxGroup.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  extraClasses: PropTypes.string,
  options: PropTypes.array,
  selecteds: PropTypes.array,
  disabled: PropTypes.bool
}

CheckboxGroup.defaultProps = {
  label: '',
  onChange: () => {},
  extraClasses: '',
  options: [],
  selecteds: [],
  disabled: false
}

export default CheckboxGroup
